module.exports = __webpack_public_path__ + "img/Dahlberg-23.f1dff11a.jpg";